const HOST = process.env.HOSTNAME || 'localhost';

export default {
    api: {
        vezetvsem: {
            url: '//localhost/api',
            key: 'dy6bW8D1yEFjk1PsrAKNAfnLNfVWJNOiwusUk2a5',
        },
    },
    ga: {
        tracking: 'UA-18075654-1',
    },
    yandex_map: {
        key: '',
    },
    google_api: {
        api_key: 'AIzaSyAowmYnPFsRIIEyVdQ8ShcC6i4ytFhqvDc',
    },
    social: {
        yandex: {
            client_id: '91702c52ee574d609ce97b1d02f624cf',
        },
        google: {
            client_id: '295608474853-lei4d18na48th5rfs7rrtleg7bcji279.apps.googleusercontent.com',
            redirect_uri: `http://${HOST}:3000/booking/social_auth/google`,
        },
        facebook: {
            client_id: '297445750366171',
            redirect_uri: `http://${HOST}:3000/booking/social_auth/facebook`,
        },
        mailru: {
            client_id: '743486',
            redirect_uri: `http://${HOST}:3000/booking/social_auth/mailru`,
        },
        ok: {
            client_id: '94011136',
            redirect_uri: `http://${HOST}:3000/booking/social_auth/ok`,
        },
        vk: {
            client_id: '4020835',
            redirect_uri: `http://${HOST}:3000/booking/social_auth/vk`,
        },
    },
    lang: 'ru',
    israel_hosts: [
        'vezet-vsem.ru',
        'www.vezet-vsem.ru',
        'movan.co.il',
        'www.movan.co.il',
        'tony.d.vezetvsem.info',
    ],
    facebook_pixel: {
        id: '517499426732228',
    },
};



// WEBPACK FOOTER //
// ./configs/development/client.config.js